import type { Ceremony, CeremonyDocument } from './types'

function textDocument(id: string, name: string, text: string): CeremonyDocument {
  const file = new File([text], name, { type: 'text/plain;charset=utf-8', lastModified: 0 })
  return { id, name, sizeBytes: file.size, file }
}

export function emptyCeremony(): Ceremony {
  return {
    kind: null,
    venueSupplierId: null,
    officiantSupplierId: null,
    officiantArrival: null,
    brideWitnessId: null,
    groomWitnessId: null,
    roles: [],
    steps: [],
    preparations: [],
    documents: [],
    notes: '',
    planB: null,
  }
}

export function planningCeremony(): Ceremony {
  return {
    kind: 'civil',
    venueSupplierId: 'sup-loucen',
    officiantSupplierId: 'sup-eva',
    officiantArrival: '13:30',
    brideWitnessId: 'g15',
    groomWitnessId: 'g7',
    roles: [
      { id: 'rings', title: 'Prstýnky', person: { type: 'guest', id: 'g7' } },
      { id: 'seating', title: 'Usazení hostů', person: { type: 'guest', id: 'g15' } },
    ],
    steps: [
      {
        id: 'seating',
        title: 'Usazení hostů',
        description: 'Rodina v prvních řadách, ostatní volně.',
        durationMinutes: 10,
        people: [{ type: 'guest', id: 'g15' }],
      },
      {
        id: 'entrance',
        title: 'Nástup k obřadu',
        description: 'Petr s maminkou, potom Anna s tatínkem.',
        durationMinutes: 3,
        people: [],
      },
      {
        id: 'welcome',
        title: 'Úvodní slovo',
        description: 'Přivítání a náš příběh od oddávající.',
        durationMinutes: 5,
        people: [{ type: 'supplier', id: 'sup-eva' }],
      },
      {
        id: 'vows',
        title: 'Sliby a prstýnky',
        description: 'Vlastní sliby. Prstýnky podává Ondřej.',
        durationMinutes: null,
        people: [{ type: 'guest', id: 'g7' }],
      },
      {
        id: 'exit',
        title: 'Odchod a špalír',
        description: 'Okvětní lístky připraví Tereza.',
        durationMinutes: null,
        people: [{ type: 'guest', id: 'g15' }],
      },
      {
        id: 'congratulations',
        title: 'Gratulace',
        description: 'Na nádvoří, potom společné focení.',
        durationMinutes: null,
        people: [],
      },
    ],
    planB: { location: 'Zámecká kaple', decisionByMemberId: null, decisionTime: null },
    preparations: [
      {
        id: 'chairs',
        title: 'Židle a ulička',
        description: 'První dvě řady pro rodinu. Uprostřed nechat širokou uličku pro nástup.',
        person: { type: 'supplier', id: 'sup-loucen' },
      },
      {
        id: 'sound',
        title: 'Ozvučení',
        description:
          'Jeden bezdrátový mikrofon pro oddávající a sliby. Vyzkoušet před příchodem hostů.',
        person: { type: 'member', id: 'm-petr' },
      },
      {
        id: 'petals',
        title: 'Okvětní lístky na špalír',
        description: 'Košíky připravit vedle poslední řady židlí.',
        person: { type: 'guest', id: 'g15' },
      },
    ],
    documents: [
      textDocument(
        'seating-plan',
        'Rozmístění židlí.txt',
        'OBŘAD V ZÁMECKÉ ZAHRADĚ\n\nPrvní dvě řady pro rodinu. Ostatní hosté se usadí volně.\nUprostřed nechat širokou uličku pro nástup.\nKošíky s okvětními lístky připravit vedle poslední řady.\n\nPři dešti se obřad přesune do zámecké kaple.',
      ),
      textDocument(
        'officiant-text',
        'Text pro oddávající.txt',
        'ANNA A PETR\n\nProsíme o krátké přivítání a náš společný příběh.\nPotom prostor pro vlastní sliby, předání prstýnků a závěrečné slovo.\nSliby si necháme jako překvapení.\n\nPrstýnky podává Ondřej. Po odchodu následují gratulace na nádvoří.',
      ),
    ],
    notes:
      'Sliby si necháme jako překvapení. Oddávající prosíme o krátké přivítání a prostor pro náš příběh.\n\nVytištěný scénář vezme Jana, jednu kopii necháme u ozvučení.',
  }
}
